/* eslint-disable no-unused-vars */
/* eslint-disable no-new */

import BadgerAccordion from 'badger-accordion'

const accordions = [...document.querySelectorAll('.js-badger-accordion')]

if (accordions.length) {
    accordions.forEach(element => {
        const accordion = new BadgerAccordion(element)
        const resetHeight = () => {
            var panel = element.querySelector('.js-badger-accordion-panel')
            var panelInner = element.querySelector('.js-badger-accordion-panel-inner')
            var activeHeight = panelInner.offsetHeight
            return panel.style.maxHeight = "".concat(activeHeight, "px")
        }
        window.addEventListener('resize', resetHeight)
    })
}